import React from 'react';

import { P3Bold } from '../../../Common/DesignSystem/Text';

export const DeviceStatus = ({ isDeviceOnline, textStyle = null }) => (
	<div className='device-info'>
		<div className={`device-status-badge ${isDeviceOnline ? 'online' : 'offline'}`} />
		<P3Bold style={textStyle}>{isDeviceOnline ? 'Online' : 'Offline'}</P3Bold>
	</div>
)